import React, { useEffect, useState, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";

import Breadcrumb from "../../component/breadcrumb/breadcrumb";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./nursingSubcategory.css";
import Mobile from "../../component/mobile/mobile";
import expect1 from "../../assets/expect1.png";
import expect2 from "../../assets/expect2.png";
import expect3 from "../../assets/expect3.png";
import expect4 from "../../assets/expect4.png";
import expect5 from "../../assets/expect5.png";
import expect6 from "../../assets/expect6.png";
import nursingSubcategorylast from "../../assets/nursingSubcategorylast.png";
import { useNavigate } from "react-router-dom";
import { Subservices } from "../../env/action";
import { UserContext } from "../../context/UserContext";
import comingsoongifimg from "../../assets/source.gif";

const NursingServiceSubcategory = () => {
  const { setSubserviceid } = useContext(UserContext);
  const { service_id } = useParams();
  const location = useLocation();
  const { serviceName, id: stateId } = location.state || {};
  const [servicedata, setservicedata] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const params = { service_id: service_id };

      Subservices(params, (res) => {
        if (res.status === 1) {
          setservicedata(res.data);
        } else {
          console.log("No subservices found");
        }
        setLoading(false);
      });
    };
    fetchData();
  }, [service_id]);

  const handleSubserviceClick = (subservice_id, subservice_name) => {
    setSubserviceid(subservice_id);
    localStorage.setItem('selectedSubserviceName', subservice_name);
  };

  return (
    <>
      <Breadcrumb
        breadcrumbTitle={serviceName}
        breadcrumbNav={[{ navText: "Home", path: "/" }]}
      />
      <div className="container nursingSubcategory mt-5">
        <div className="mt-3">
          <p className="text-center fw-bolder text-1">
            Compassionate Nursing Services Provided at Home by a Licensed
            Professional
          </p>
        </div>
        <div className="row card-container mt-5 justify-content-center">
          {loading ? (
            <Skeleton count={3} />
          ) : servicedata.length === 0 ? (
            <div className="coming-soon-message">
              <div className="gif-container text-center">
                <img
                  src={comingsoongifimg}
                  alt="Coming Soon GIF"
                  className="coming-soon-gif"
                />
              </div>
            </div>
          ) : (
            servicedata.map((subservice, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <Link
                  to={`/${subservice.web_screen_name}/${subservice.subservice_id}`}
                  // onClick={() =>
                  //   handleSubserviceClick(subservice.subservice_id, subservice.subservice_name, subservice.web_screen_name)
                  // }
                  onClick={() => {
                    setSubserviceid(subservice.subservice_id);
                    localStorage.setItem(
                      "selectedSubserviceName",
                      subservice.subservice_name
                    );
                  }}
                >
                  <div className="card position-relative">
                    <div
                      className="card-img"
                      style={{
                        backgroundImage: `url(${subservice.icon})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                    >
                      <div className="dark-overlay"></div>
                      <div className="overlay-box">
                        <p
                          style={{
                            margin: "0",
                            fontSize: "18px",
                            fontWeight: "600",
                            color: "#fff",
                            letterSpacing: "1px",
                          }}
                        >
                          {subservice.subservice_name}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))
          )}
        </div>
        <div className="expect mt-5 shadow p-4">
          <p className="text-center fs-2 fw-bolder">What to Expect</p>
          <div className="row mt-5">
            <div className="col-md-4 d-flex justify-content-center">
              <div className="wte w-75">
                <img
                  src={expect1}
                  width={"40px"}
                  height={"40px"}
                  alt="expectation"
                />
                <p className="ms-3 fw-medium">12/24-Hour Nurse-At-Home</p>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-center">
              <div className="wte w-75">
                <img
                  src={expect2}
                  width={"40px"}
                  height={"40px"}
                  alt="expectation"
                />
                <p className="ms-3 fw-medium">
                  Background Checks of all Nurses
                </p>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-center">
              <div className="wte w-75">
                <img
                  src={expect3}
                  width={"40px"}
                  height={"40px"}
                  alt="expectation"
                />
                <p className="ms-3 fw-medium">Temperature/BP/ Sugar check</p>
              </div>
            </div>

            <div className="col-md-4 d-flex justify-content-center">
              <div className="wte w-75">
                <img
                  src={expect4}
                  width={"40px"}
                  height={"40px"}
                  alt="expectation"
                />
                <p className="ms-3 fw-medium">Multilingual Nurses</p>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-center">
              <div className="wte w-75">
                <img
                  src={expect5}
                  width={"40px"}
                  height={"40px"}
                  alt="expectation"
                />
                <p className="ms-3 fw-medium">High Alert Medication</p>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-center">
              <div className="wte w-75">
                <img
                  src={expect6}
                  width={"40px"}
                  height={"40px"}
                  alt="expectation"
                />
                <p className="ms-3 fw-medium">
                  Repositioning Bedridden Patients
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          src={nursingSubcategorylast}
          className="nursingSubcategorylast"
          alt="Nursing services"
        />
      </div>
      <Mobile />
    </>
  );
};

export default NursingServiceSubcategory;
